import achu_muruku from "./njsweets/achu_muruku.png";
import somas from "./njsweets/somas.png";
import karasev from "./njsweets/karasev.png";
import mixture_green_peas from "./njsweets/mixture_green_peas.png";
import thattai from "./njsweets/thattai.png";
import mysorepak from "./njsweets/mysorepak.png";
import mysorepak_ghee from "./njsweets/mysorepak_ghee.png";
import kaju_katli from "./njsweets/kaju_katli.png";
import badhusa from "./njsweets/badhusa.png";
import mysorepak_badhusa from "./njsweets/mysorepak_badhusa.png";
import athirasam_001 from "./njsweets/athirasam-001.png";

import alteration_photo from "./tailor/all-services/alteration.jpeg";
import saree_threading from "./tailor/all-services/saree-threading.jpeg";
import tailor_home_aari from "./tailor/all-services/aari.jpeg";
import tailor_home_blouse from "./tailor/all-services/blouse.jpeg";
import tailor_home_half_saree_photo from "./tailor/all-services/half_saree.png";
import tailor_home_kids_photo from "./tailor/all-services/kids_dress.jpeg";
import tailor_home_thanjavur_photo from "./tailor/all-services/thanjavur-painting.png";
import tailor_home_lehenga_photo from "./tailor/all-services/lehanga.png";
import tailor_home_saree_falls_photo from "./tailor/all-services/saree-falls.png";

const imageMap = {
  achu_muruku,
  somas,
  karasev,
  mixture_green_peas,
  thattai,
  mysorepak,
  mysorepak_ghee,
  kaju_katli,
  badhusa,
  mysorepak_badhusa,
  athirasam_001,

  // Tailoring items with a single photo (not a multi-photo gallery folder).
  tailoring_half_saree: saree_threading,

  // "All Services" homepage tile photos (see TailorServiceGrid.jsx) - all sourced
  // from tailor/all-services/ per instruction, placeholder where no photo exists yet.
  tailor_home_aari,
  tailor_home_blouse,
  tailor_home_alteration: alteration_photo,
  tailor_home_half_saree: tailor_home_half_saree_photo,
  tailor_home_saree_threading: saree_threading,
  tailor_home_kids: tailor_home_kids_photo,
  tailor_home_thanjavur: tailor_home_thanjavur_photo,
  tailor_home_lehenga: tailor_home_lehenga_photo,
  tailor_home_saree_falls: tailor_home_saree_falls_photo,
};

export default imageMap;

// Auto-loads every image from a product's photo folder, e.g. src/components/assets/cakes/honey/*
// or src/components/assets/tailor/aari/* - grouped by folder name, keyed for use as
// productCatalog's `gallery` field. Drop new photos in the matching folder; no code change needed.
function loadGalleries(context) {
  const groups = {};
  context.keys().forEach((key) => {
    // key looks like "./aari/Aari-Work-002-100.png" or "./aari/design-001/foo.jpeg" -
    // group by everything between the top folder and the filename, so both flat
    // folders (gallery: "honey") and nested per-design folders (gallery: "aari/design-002") work.
    const folder = key.split("/").slice(1, -1).join("/");
    if (!folder) return; // skip loose files with no subfolder
    (groups[folder] = groups[folder] || []).push(context(key));
  });
  return groups;
}

export const galleries = {
  ...loadGalleries(require.context("./cakes", true, /\.(png|jpe?g)$/i)),
  ...loadGalleries(require.context("./tailor", true, /\.(png|jpe?g)$/i)),
};
